var storefrontApp = angular.module("storefrontApp");
storefrontApp.controller("sewingController", [
    "$scope", "$rootScope", "sewingService", "catalogService", "elasticService", "randomService", "$interval",
    function (
        $scope, $rootscope, sewingService, catalogService, elasticService, randomService, $interval
    ) {

        $rootscope.activeBannerIndex = 0;

        $scope.onBannerClick = function(index){
            if($scope.banners && $scope.banners.length > 0){
                $rootscope.activeBannerIndex = index;
            }
            else{
                $rootscope.activeBannerIndex = 0;
            }
        }

        $scope.getSewingPageContent = function(){
            sewingService.getSewingPageContent().then(
                function (response) {
                    if(response && response.data){
                        $scope.banners = response.data.banners;
                        $scope.ads = response.data.ads;
                        $scope.navOptions = response.data.navoptions;
                        $scope.splAds = response.data.splAds;

                        $scope.carousalInterval = $interval(
                            function(){
                                val = 1;
                                if ($scope.banners && $scope.banners.length > 0) {
                                    if (!(($scope.banners.length - 1 == $rootscope.activeBannerIndex && Number(val) > 0) || ($rootscope.activeBannerIndex == 0 && Number(val) < 0))) {
                                        $rootscope.activeBannerIndex = Number($rootscope.activeBannerIndex) + Number(val);
                                    }
                                    else {
                                        $rootscope.activeBannerIndex = 0;
                                    }
                                }
                            }, 5000
                        );

                        // $scope.sewingSupplies = response.data.sewingSupplies;
                        var sewingSuppliesIds = response.data.sewingSupplies;

                        elasticService.getElasticData(
                            elasticService.buildProductByIdsRequest(
                                angular.toJson(
                                    sewingSuppliesIds.map(function(id){
                                        return id.toLowerCase().indexOf("_var_") == -1
                                        ? id.toLowerCase()
                                        : id.toLowerCase().split("_var_")[0]
                                    })
                                )
                            )
                        ).then(
                            function(response){
                                if(response && response.data && response.data.hits && response.data.hits.hits){
                                    $scope.sewingSupplies = randomService.getRandomItemsfromListArray(
                                        response.data.hits.hits, 6
                                    );
                                }
                            }
                        );
                    }
                }
            );
        }
        $scope.getSewingPageContent();

        $scope.getSewingPatternsProjects = function(){
            var targetPrdDefs = [
                catalogService.productDefinition.sewingpdfpatterns,
                catalogService.productDefinition.knittingpdfpatterns,
                catalogService.productDefinition.crochetpdfpatterns,
                catalogService.productDefinition.clothingpdfpatterns,
                catalogService.productDefinition.crossstitchpdfpatterns,
                catalogService.productDefinition.handembroidery
            ]
            sewingService.getProjectsByDefinitions(
                targetPrdDefs.join(",") , 15
            ).then(
                function (response) {
                    if(response && response.data){
                        $scope.projects = randomService.getRandomItemsfromListArray(
                            response.data, 4
                        );
                    }
                }
            );
        }
        $scope.getSewingPatternsProjects();

        function filterData(data, key, value) {
            var filteredData = data.filter(
                function (data) {
                    return (data[key] && data[key].toLowerCase()) == value.toLowerCase()
                }
            );
            return (filteredData && filteredData != null && filteredData.length > 0) ? filteredData[0] : undefined;
        }

        elasticService.getElasticData(elasticService.buildNewArrivalsRequest(
            ["Hand Embroidery", "Cross Stitch PDF Patterns"], 50)
        ).then(
            function (response) {
                if (response && 'aggregations' in response.data) {

                    var newArrivals = response.data.aggregations.definitions.buckets;
                    $scope.handEmbroidery = randomService.getRandomItemsfromListArray(
                        filterData(newArrivals, "key", "Hand Embroidery").topByDefinitions.hits.hits
                    );
                    $scope.pdfCrossStitchPattern = randomService.getRandomItemsfromListArray(
                        filterData(newArrivals, "key", "Cross Stitch PDF Patterns").topByDefinitions.hits.hits
                    );
                }
            }
        )
    }
]);
